import { render, staticRenderFns } from "./litifei.vue?vue&type=template&id=6e9843de&scoped=true&"
import script from "./litifei.vue?vue&type=script&lang=js&"
export * from "./litifei.vue?vue&type=script&lang=js&"
import style0 from "./litifei.vue?vue&type=style&index=0&id=6e9843de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9843de",
  null
  
)

export default component.exports